import { MessageScreen } from '@/components/MessageScreen/MessageScreen';
import { useConfig } from '@/hooks/useConfig/useConfig';
import { useAirKeyTracePageView } from '@/utils/airKeyTrace';

// TODO: Same as networkError but different images, see if we can simplify
export const FailedVerification = () => {
  const { content, locale } = useConfig();
  useAirKeyTracePageView('verification_failed');

  return (
    <MessageScreen
      iconPath={`${content.config.urlBase}${content.verificationFailed.img.src}`}
      iconSize={content.verificationFailed.img.width}
      title={content.verificationFailed.title[locale]}
      titleSize={19}
      body={content.verificationFailed.description[locale]}
    />
  );
};
